// apps/web/src/api/russia-requests/storage.ts
//
// Russia SIMPLE position photo download-URL helper (#1545). Uploads
// reuse the generic `requestUploadUrl` from the China storage module —
// the presigned-PUT endpoint is request-scope-agnostic — so only the
// per-position signed-download wrapper is Russia-pathed here.

import { StorageDownloadUrlResponseSchema, type StorageDownloadUrlResponse } from '@magimp/shared';
import { request } from '../client.js';

/**
 * @aiPurpose POST /russia-requests/:id/items/:itemId/photo-download-url.
 *   Mints a short-lived signed download URL for one saved position photo.
 *   Backend perm `russiaRequests.read`.
 * @aiSecurity the returned `downloadUrl` is bearer-like — keep it in
 *   in-memory refs only (see `DraftPhotoPreviews`); never log/persist it.
 */
export function russiaRequestItemPhotoDownloadUrl(
  requestId: string,
  itemId: string,
  objectKey: string,
): Promise<StorageDownloadUrlResponse> {
  return request<StorageDownloadUrlResponse>(
    `/russia-requests/${encodeURIComponent(requestId)}/items/${encodeURIComponent(
      itemId,
    )}/photo-download-url`,
    {
      method: 'POST',
      body: JSON.stringify({ objectKey }),
      headers: { 'content-type': 'application/json' },
    },
    {},
    StorageDownloadUrlResponseSchema,
  );
}
